<div>
  <label for="{{ itemId }}" [hidden]="!label || label.length == 0">{{
    label
  }}</label>
  <textarea
    rows="3"
    id="{{ itemId }}"
    [(ngModel)]="value"
    placeholder="{{ placeholder }}"
    (change)="update()"
    [attr.maxlength]="maxLength"
  ></textarea>
</div>
